var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.chargingStation.coordinates)?_c('l-marker',{attrs:{"lat-lng":[
    _vm.chargingStation.coordinates.latitude,
    _vm.chargingStation.coordinates.longitude,
  ],"icon":_vm.getIcon(_vm.pinIcon)},on:{"click":_vm.pinClick}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }